<template>
    <div 
      class="flash-light" 
      :class="{ 'flash-light-on': isFlashOn }" 
      @click="toggleFlashlight"
    >
      <img src="https://icons.veryicon.com/png/o/miscellaneous/ionicons/ios-flashlight-1.png" />
    </div>
  </template>
  
  <script setup>
  import { ref, onUnmounted } from 'vue'
  
  const isFlashOn = ref(false)
  const videoTrack = ref(null)
  
  navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
    .then((stream) => {
      videoTrack.value = stream.getVideoTracks()[0]
    })
    .catch((err) => {
      console.warn('Impossible d’accéder à la caméra :', err)
    })
  
  const toggleFlashlight = async () => {
    if (!videoTrack.value) return
  
    try {
      isFlashOn.value = !isFlashOn.value
      await videoTrack.value.applyConstraints({
        advanced: [{ torch: isFlashOn.value }]
      })
    } catch (e) {
      console.warn('Le flash n\'est pas supporté sur cet appareil.')
      alert('Le flash n\'est pas disponible sur cet appareil.')
    }
  }

  onUnmounted(async () => {
  if (videoTrack.value && isFlashOn.value) {
    try {
      await videoTrack.value.applyConstraints({
        advanced: [{ torch: false }]
      })
      isFlashOn.value = false
    } catch (e) {
      console.warn('Erreur lors de l’extinction du flash.')
    }
  }
})
  </script>
  
  <style scoped>
  .flash-light {
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: clamp(50px, 10vw, 70px);
  aspect-ratio: 1/1;
  bottom: 10%;
  right: 50%;
  transform: translate(50%, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  z-index: 1001;
  transition: background 0.3s ease, backdrop-filter 0.3s ease;
}
  
.flash-light-on {
  background: radial-gradient(black, grey);
}
  
  .flash-light img {
    filter: invert(1);
    width: 90%;
    height: 80%;
  }
  </style>